import React from 'react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-12 overflow-hidden bg-surface-deepest" data-id="element-63">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-64"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-8" data-id="element-65">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4" data-id="element-66">
          Carisma al instante: Los 17{' '}
          <span className="text-gold italic" data-id="element-67">"Trucos"</span> Mentales para
          Volverte el Hombre más{' '}
          <span className="text-gold italic" data-id="element-68">Carismático</span> de la Sala
        </h1>

        <p className="font-heading text-xl md:text-2xl text-gray-400 italic mb-8" data-id="element-69">
          (Incluso si te consideras tímido, introvertido o vergonzoso)
        </p>

        <p className="font-body text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-70">
          Domina la psicología de la atracción social, proyecta una seguridad
          inquebrantable y haz que tu presencia sea imposible de ignorar. Sin
          atajos baratos, solo ciencia aplicada para que ellas (y todos) busquen
          tu atención.
        </p>
      </div>
    </section>;
}